import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "./login.scss";
import { getApiInstance } from "../../utils/api";
import { mensajeErrorAuth, validarPassword } from "../../utils/authUtils";
import Input from "../../components/inputs/input/input";
import Button from "../../components/button/button";
import LoginLayout from "./loginLayout";

// Destino del enlace del correo "Restablece tu contraseña de Book":
// /definir-password?email=...&token=...  (el API lo genera en Auth/forgot-password).
export default function DefinirPassword() {
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email") || "";
    const token = searchParams.get("token") || "";

    const [password, setPassword] = useState("");
    const [confirmacion, setConfirmacion] = useState("");
    const [error, setError] = useState("");
    const [hecho, setHecho] = useState("");
    const [enviando, setEnviando] = useState(false);

    const enlaceValido = email && token;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (enviando) return;

        const errorPassword = validarPassword(password);
        if (errorPassword) {
            setError(errorPassword);
            return;
        }
        if (password !== confirmacion) {
            setError("Las contraseñas no coinciden.");
            return;
        }

        setError("");
        setEnviando(true);
        try {
            const api = getApiInstance();
            const response = await api.post("/api/Auth/definir-password", {
                email,
                token,
                password,
            });
            setHecho(
                response.data?.message ||
                    "Contraseña definida correctamente. Ya puedes iniciar sesión."
            );
        } catch (error) {
            setError(
                mensajeErrorAuth(
                    error,
                    "No se ha podido definir la contraseña. Pide un enlace nuevo."
                )
            );
        } finally {
            setEnviando(false);
        }
    };

    return (
        <LoginLayout>
                <h2 className="login__right__title">Define tu contraseña</h2>

                {!enlaceValido && (
                    <div className="login__right__form">
                        <p className="login__right__form__error">
                            El enlace no es válido. Pide uno nuevo desde "¿Has olvidado tu
                            contraseña?".
                        </p>
                        <Link className="login__right__form__link" to="/login">
                            Ir a iniciar sesión
                        </Link>
                    </div>
                )}

                {enlaceValido && hecho && (
                    <div className="login__right__form">
                        <p className="login__right__form__notice">{hecho}</p>
                        <Button
                            label="Iniciar sesión"
                            variant="filled"
                            path="/login"
                            fullWidth={true}
                        />
                    </div>
                )}

                {enlaceValido && !hecho && (
                    <form className="login__right__form" onSubmit={handleSubmit}>
                        <p className="login__right__form__notice">
                            Cuenta: <strong>{email}</strong>. Mínimo 8 caracteres.
                        </p>
                        <Input
                            type="password"
                            label="Nueva contraseña"
                            name="password"
                            placeholder="Introduce tu nueva contraseña"
                            value={password}
                            autoComplete="new-password"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <Input
                            type="password"
                            label="Repite la contraseña"
                            name="confirmacion"
                            placeholder="Repite la nueva contraseña"
                            value={confirmacion}
                            autoComplete="new-password"
                            onChange={(e) => setConfirmacion(e.target.value)}
                        />
                        <div className="login__right__form__button">
                            <Button
                                label="Guardar contraseña"
                                variant="filled"
                                type="submit"
                                fullWidth={true}
                                state={enviando ? "loading" : "default"}
                            />
                        </div>
                        {error && (
                            <p className="login__right__form__error">{error}</p>
                        )}
                        <Link className="login__right__form__link" to="/login">
                            Volver a iniciar sesión
                        </Link>
                    </form>
                )}
        </LoginLayout>
    );
}
